import script from "./ActionDescription.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionDescription.vue?vue&type=script&lang=ts&setup=true"

import "./ActionDescription.vue?vue&type=style&index=0&id=42ef6e94&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ef6e94"]])

export default __exports__